import type { C1_BaseObject } from "./C1_BaseObject";

export class C1_ObjectRegistry {
  readonly allObjects = new Map<string, C1_BaseObject<any>>();

  registerObject(object: C1_BaseObject<any>): void {
    this.allObjects.set(object.id, object);
  }

  getObject<T extends C1_BaseObject<any>>(id: string | undefined): T | undefined {
    if (!id) return undefined;
    return this.allObjects.get(id) as T | undefined;
  }

  removeObject(object: C1_BaseObject<any>, id = object.id): void {
    if (this.allObjects.get(id) === object) {
      this.allObjects.delete(id);
    }
  }

  clear(): void {
    this.allObjects.clear();
  }
}
